export default __webpack_public_path__ + "static/media/mozart5.88879760.png";